// src/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";

function AdminLogin({ setIsAdmin }) {
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const auth = getAuth();

  // ✅ Google Sign-In (the only method now)
  const handleGoogleLogin = async () => {
    setError("");
    const provider = new GoogleAuthProvider();

    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
      console.log("✅ Logged in as:", result.user.email);

      // 🔎 Check for admin claim
      const token = await result.user.getIdTokenResult(true);
      if (token.claims.admin) {
        console.log("🎉 Admin claim detected — granting access.");
        setIsAdmin(true);
        navigate("/");
      } else {
        setError("⚠️ This Google account is not marked as admin.");
      }
    } catch (err) {
      console.error("❌ Google login error:", err);
      setError("❌ Google login failed. See console for details.");
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setIsAdmin(false);
    console.log("👋 Logged out");
  };

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "100px",
        fontFamily: "sans-serif",
      }}
    >
      <h2>Admin Access</h2>

      {/* 🔹 Google Sign-In button */}
      <button
        onClick={handleGoogleLogin}
        style={{
          padding: "8px 16px",
          backgroundColor: "#db4437",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Sign in with Google
      </button>

      {user && (
        <div style={{ marginTop: "20px" }}>
          <p>Logged in as {user.email}</p>
          <button
            onClick={handleLogout}
            style={{
              backgroundColor: "#888",
              color: "white",
              border: "none",
              borderRadius: "5px",
              padding: "6px 12px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      )}

      {error && (
        <p style={{ color: "red", marginTop: "10px", fontSize: "12px" }}>
          {error}
        </p>
      )}
    </div>
  );
}

export default AdminLogin;
